<template>
  <iRow width="hug">
    <iTextEditInput
      v-model="localBio"
      label="Bio"
      :min-width="400"
      text-area
      :text-area-rows="3"
      editable-on-click
      :disabled="editMode"
      @submit="submit"
    />
  </iRow>
</template>

<script>
// `~/stores/user-store` lives outside the editor directory tree.
import { UserSettingsPageElementMixin } from "%/dynamic-component-editor/standard-pages/user-settings-page/user-settings-page-element-mixin";

export default {
  name: "ChangeBio",
  mixins: [UserSettingsPageElementMixin],
  elementPanelSettings: {
    displayName: "Change Bio Field",
    displayIcon: "document",
    elementGroup: "userSettingsElements",
    elementType: "element",
  },
  data() {
    return {
      localBio: "Example bio",
    };
  },
  methods: {
    submit() {
      // No-op in Studio canvas preview.
    },
  },
};
</script>
